import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { NotaFiscalGlobalFilters, NotaFiscalGlobalListItem } from './types';

/**
 * Listagem global de NFs Colaborador — `ApiEmployeeNotaFiscalListAll`, publicado
 * pela Genie (card [snzKX9aT]/ATD-0056, GATE_OK 2026-08-23; smoke verde). BFF
 * roteia a rota estática `GET /employees/notas-fiscais`.
 *
 * Atenção: o filtro de status usa o param `statusNotaFiscal` (não `status`) —
 * confirmado no smoke (o campo do DTO é `status`, mas o param da proc é
 * `&statusNotaFiscal`).
 *
 * O param `nfPaga` (tri-estado: omitido = todas, `true`/`1` = pagas,
 * `false`/`0` = não pagas) filtra por NF paga/não paga e combina com os demais
 * (AND) — publicado pela Genie (card [odX4fYq4]/ATD-0060, GATE_OK 2026-08-25;
 * smoke verde: 281 pagas + 28 não pagas = 309 total).
 */
const BASE = '/v1/employees/notas-fiscais';

export const notasGlobalApi = {
  async list(
    query: DataTableQuery,
    filters?: NotaFiscalGlobalFilters,
  ): Promise<ListEnvelope<NotaFiscalGlobalListItem>> {
    const { data } = await api.get<{
      data: NotaFiscalGlobalListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, {
      params: toGenexusParams(query, {
        colaboradorCodigo: filters?.colaboradorCodigo ?? undefined,
        clienteCodigo: filters?.clienteCodigo ?? undefined,
        statusNotaFiscal: filters?.status || undefined,
        mes: filters?.mes ?? undefined,
        ano: filters?.ano ?? undefined,
        nfPaga: filters?.nfPaga ?? undefined,
      }),
    });
    return normalizeListEnvelope(data);
  },
};
